import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export const buttonVariants = [
    'primary',
    'secondary',
    'text',
];
export const buttonSizes = ['small', 'medium'];
export const buttonTypes = ['button', 'reset', 'submit'];
export const buttonPropTypes = {
    disabled: PropTypes.bool,
    href: PropTypes.string,
    icon: PropTypes.node,
    name: PropTypes.string,
    newWindow: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(buttonSizes),
    stretch: PropTypes.bool,
    type: PropTypes.oneOf(buttonTypes),
    value: PropTypes.string,
    variant: PropTypes.oneOf(buttonVariants).isRequired,
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=Button.types.js.map